import React from 'react';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import { VpIcon } from '../VpIcon';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

export const StyledTooltip = styled(
  ({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />,
  {
    shouldForwardProp: (prop) => prop !== 'isCard'
  }
)(({ theme, isCard }) => ({
  '& a': {
    color: theme?.palette?.vpColors?.white,
    textDecoration: 'underline'
  },
  ...(isCard && {
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.vpColors.white,
      color: theme.palette.vpColors.greyDark,
      // default card box shadow
      boxShadow:
        '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
      border: `1px solid ${theme.palette.vpColors.greyLight}`,
      padding: '10px'
    }
  })
}));

export const StyledStack = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'fullWidth' && prop !== 'disableFlex'
})(({ fullWidth, disableFlex }) => ({
  display: disableFlex ? 'block' : 'flex',
  flexDirection: 'row',
  gap: '5px',
  marginBottom: '5px',
  alignItems: 'center',
  width: fullWidth ? '100%' : 'fit-content'
}));

export const StyledBox = styled(Stack, {
  shouldForwardProp: (prop) =>
    prop !== 'fullWidth' && prop !== 'disablePointer' && prop !== 'disableFlex'
})(({ disablePointer, fullWidth, disableFlex }) => ({
  flexDirection: 'row',
  display: disableFlex ? 'block' : 'flex',
  cursor: disablePointer ? 'default' : 'pointer',
  ...(fullWidth && {
    width: '100%'
  })
}));
export const StyledVpIcon = styled(VpIcon)(({ theme, ...props }) => ({
  position: 'static !important',
  color: theme.palette.vpColors[props?.iconColor] || theme.palette.vpColors.greyDark
}));



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpHoverInfo/styles.js